import dJSON from 'dirty-json';

const moduleSelector = '.locations-section';

/**
 * CMS map fields sometimes contain a full <iframe> instead of a URL.
 * Quotes inside that HTML break JSON once the template literal is evaluated.
 */
function parseModuleData(raw) {
  if (raw && typeof raw === 'object') return raw;

  const text = String(raw ?? '').replace(/<iframe\b[\s\S]*?<\/iframe>/gi, (iframe) => {
    const srcMatch = iframe.match(/\bsrc\s*=\s*["']([^"']+)["']/i);
    return srcMatch ? srcMatch[1] : '';
  });

  return dJSON.parse(text);
}

function getMapSrc(map) {
  if (!map) return '';
  const value = String(map).trim();
  const iframeSrc = value.match(/<iframe\b[^>]*\bsrc=["']([^"']+)["']/i);
  return iframeSrc ? iframeSrc[1] : value;
}

/**
 * Module Init
 */
(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query) => {
    try {
      query.querySelector('script')?.remove(); // cleanup

      const { data } = parseModuleData(query.data);

      const grid = query.querySelector('.locations-section__grid');
      data.forEach((item) => {
        const itemEl = document.createElement('div');
        itemEl.classList.add('locations-section__item');
        itemEl.innerHTML = /* html */ `
          <div class="locations-section__map">
            <iframe src="${getMapSrc(item.map)}" width="100%" height="100%" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          </div>
          <div class="locations-section__item__content">
            <h3 class="title-decoration">${item.location}</h3>
            <h2>${item.title}</h2>
            <ul class="list-custom">
              <li>
                <img src="https://us.evocdn.io/dealer/1569/content/media/My_Theme/icons/map-pin.svg" alt="Map Pin" width="16" height="16">
                ${item.address}
              </li>
              <li>
                <img src="https://us.evocdn.io/dealer/1569/content/media/My_Theme/icons/phone.svg" alt="Phone" width="16" height="16">
                <a href="tel:${item.phone}">${item.phone}</a>
              </li>
              <li>
                <img src="https://us.evocdn.io/dealer/1569/content/media/My_Theme/icons/email.svg" alt="Email" width="16" height="16">
                <a href="mailto:${item.email}">${item.email}</a>
              </li>
            </ul>
            <a href="/contact" class="btn-custom primary">Contact Us</a>
          </div>
        `;
        grid.appendChild(itemEl);
      });
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();
